module.exports = __webpack_public_path__ + "img/landing-1-de-DE.d04c830.png";